export default "__VITE_ASSET__Dv5tjvxP__"